import { render } from "./SelectDownItemRedesign.vue?vue&type=template&id=2dfb7cd2&scoped=true"
import script from "./SelectDownItemRedesign.vue?vue&type=script&lang=js"
export * from "./SelectDownItemRedesign.vue?vue&type=script&lang=js"

import "./SelectDownItemRedesign.vue?vue&type=style&index=0&id=2dfb7cd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfb7cd2"]])

export default __exports__